import sponsoring from "../../../config/sponsoring";
import styles from "./sponsoren.module.css";
import { toast } from 'react-toastify';
function Sponsoren() {
    const handleClick = (link) => {
        if (link) {
            window.open(link, "_blank");
        } else {
            toast.warning("Dieser Sponsor hat keinen Link!");
        }
    };
    const shuffledPremium = [...sponsoring.premium].sort(() => Math.random() - 0.5);
    const normalPremium = [...sponsoring.normal].sort(() => Math.random() - 0.5);

    return (
        <section className={styles.contentWrapper}>
            <h1>Sponsoren</h1>
            <section className={styles.sponsoren}>
                {shuffledPremium.map((item, index) => (
                    <div className={styles.premiumWrapper}
                        onClick={() => handleClick(item.link)}
                        style={{ cursor: "pointer" }}
                    >
                        <img src={`/uploads/sponsoren/${item.img}`}
                            alt={`${item.name}`}
                        />
                    </div>
                ))}
            </section>
            <section className={styles.sponsoren}>
                {normalPremium.map((item, index) => (
                    <div className={styles.normalWrapper}
                        onClick={() => handleClick(item.link)}
                        style={{ cursor: "pointer" }}
                    >
                        <img src={`/uploads/sponsoren/${item.img}`}
                            alt={`${item.name}`} />
                    </div>
                ))}
            </section>

        </section>
    );
};
export default Sponsoren;